import { actionTypes } from './actions';

const initialState = [];

const appendToast = (message, state, variant) => [
  ...state, { message, variant },
];

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.TOAST_ERROR: {
      const { message } = action.payload;
      return appendToast(message, state, 'error');
    }
    case actionTypes.TOAST_INFO: {
      const { message } = action.payload;
      return appendToast(message, state, 'info');
    }
    case actionTypes.TOAST_REMOVE: {
      return state.slice(1);
    }
    case actionTypes.TOAST_SUCCESS: {
      const { message } = action.payload;
      return appendToast(message, state, 'success');
    }
    case actionTypes.TOAST_WARNING: {
      const { message } = action.payload;
      return appendToast(message, state, 'warning');
    }
    default: {
      return state;
    }
  }
}
